export const skusActions = {
  FETCH_SKUS_SUCCESS: "FETCH_SKUS_SUCCESS",
};

export function setSkus(productId, skus) {
  return {
    type: skusActions.FETCH_SKUS_SUCCESS,
    payload: {
      skus,
      productId,
    },
  };
}
